export class DownloadScreen {
    public static show() {
        $('#download_client_screen').show();
    }
}
